<div id="cover-teachers" style="position: relative;" class="text-white bg-[#F5F5F5] pt-[5rem] position-relative">
  <div
    class="container lg:text-start text-center mb-[5rem] mt-[2rem] px-5 pb-[5rem] lg:flex flex-row justify-start items-center">
    <div class="contact lg:w-1/2 w-full mb-10">
      <h1 class="text-primary lg:mb-4 font-bold  xl:text-5xl lg:text-3xl md:text-2xl text-xl">Meet the
        Experts Who Shape Your Learning
      </h1>

      <ul class="text-black container">
        <li class="mb-2" style="list-style: disc;">Our highly qualified and experienced teachers bring years of subject
          expertise and deep
          knowledge of IB, A Level, AS Level, IGCSE, GCSE, CBSE, and ICSE syllabuses</li>
        <li class="mb-2" style="list-style: disc;">They
          design our revision notes, flashcards, past papers, and exam questions with precision,
          ensuring every resource is accurate and engaging.</li>
        <li class="mb-2" style="list-style: disc;">With a qualified team like this , we
          provide students with the guidance and support they need to excel.</li>
      </ul>
      <p class="text-primary text-xl my-3"> <span class="font-bold">S</span>imple design, <span
          class="font-bold">S</span>mart learning tools, and <span class="font-bold">S</span>wift progress</p>
      <!-- <app-main-btn [btnTxColor]="'white'" [borderColor]="'primary'" [btnColor]="'primary'" [btnName]="'Find Our More'" /> -->
    </div>
    <div class="cover-img  lg:w-1/2 w-full flex lg:justify-end justify-center">
      <img class="" src="Images/teachers01.png" alt="">
    </div>
  </div>

  <svg viewBox="0 0 1440 320" class="lg:block hidden" style="position: absolute; bottom:0;"
    xmlns="http://www.w3.org/2000/svg">
    <path fill="#ffffff" fill-opacity="1" d="M0,130 C360,350 400,-50 1440,120 L1440,500 L0,320 Z">
    </path>
  </svg>

  <svg viewBox="0 0 1440 320" class="block lg:hidden" style="position: absolute; bottom:0;"
    xmlns="http://www.w3.org/2000/svg">
    <path fill="#ffffff" fill-opacity="1" d="M0,80 C360,350 400,-240 1440,120 L1440,500 L0,320 Z">
    </path>
  </svg>
</div>